import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconNavigation2 = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--navigation-2")} iconColor={color} size={size} width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

      <defs>
          <path d="M12,5.89263668 L6.88738097,19.7697455 L11.5038611,17.1317569 C11.8112937,16.956081 12.1887063,16.956081 12.4961389,17.1317569 L17.112619,19.7697455 L12,5.89263668 Z M12,19.1517511 L5.49613894,22.8682431 C4.68576618,23.3313133 3.73899357,22.5300951 4.06165688,21.6542946 L11.0616569,2.65429464 C11.3830648,1.78190179 12.6169352,1.78190179 12.9383431,2.65429464 L19.9383431,21.6542946 C20.2610064,22.5300951 19.3142338,23.3313133 18.5038611,22.8682431 L12,19.1517511 Z" id="icon--centivo--navigation-2"/>
      </defs>
      <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-1367.000000, -860.000000)"/>
          <g id="Icon/navigation-2">
              <mask id="mask-2" fill="white">
                  <use xlinkHref="#icon--centivo--navigation-2"/>
              </mask>
              <use id="Shape" fill="currentColor" xlinkHref="#icon--centivo--navigation-2"/>
          </g>
      </g>
  </IconWrapper>
)
